export default "https://cdn-static.gokick.com/assets/9232f824e6a46c896411df64bf74cb68df4bd809/images/diastolic-smaller.c0fadbcdc01bd506880e051915c30039.svg";